import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tercer-paso',
  templateUrl: './tercer-paso.component.html',
  styleUrls: ['./tercer-paso.component.scss']
})
export class TercerPasoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
